import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface WhyChooseUsItem {
  id: string;
  title: string;
  description: string;
  icon: string | null;
  sort_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export type WhyChooseUsInput = Omit<WhyChooseUsItem, "id" | "created_at" | "updated_at">;

export function useWhyChooseUsAdmin() {
  return useQuery({
    queryKey: ["why-choose-us-admin"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("website_why_choose_us")
        .select("*")
        .order("sort_order", { ascending: true });
      if (error) throw error;
      return (data ?? []) as WhyChooseUsItem[];
    },
  });
}

export function useUpsertWhyChooseUs() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...input }: Partial<WhyChooseUsItem> & WhyChooseUsInput) => {
      if (id) {
        const { error } = await supabase.from("website_why_choose_us").update(input).eq("id", id);
        if (error) throw error;
      } else {
        const { error } = await supabase.from("website_why_choose_us").insert(input);
        if (error) throw error;
      }
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["why-choose-us-admin"] });
      qc.invalidateQueries({ queryKey: ["website_why_choose_us"] });
    },
  });
}

export function useDeleteWhyChooseUs() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const { error } = await supabase.from("website_why_choose_us").delete().eq("id", id);
      if (error) throw error;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["why-choose-us-admin"] });
      qc.invalidateQueries({ queryKey: ["website_why_choose_us"] });
    },
  });
}
